import {
  types as rs,
  isAvailableNow,
  utcnow,
  SimpleMenuDefProvider,
  isSetFulfillable,
  FoodSet,
  cmpTowardsBlocked,
} from 'earn-ts';
import { useAppDispatch, useAppSelector } from 'src/app/store';

// currently no way to subscribe to changes
export const useIsAvailable = () => {
  const dispatch = useAppDispatch();
  const { menuDef, session } = useAppSelector(state => state.order);

  let isTakeout = session.kind == 'Takeout';
  let tzoffset = menuDef?.tzoffset ?? 0;
  // choose one
  return (def?: rs.MenuCat | rs.FoodItem, set?: FoodSet) => {
    if (menuDef == null) return null;
    let now = utcnow();
    if (set != null) {
      return isSetFulfillable(
        new SimpleMenuDefProvider(menuDef!),
        set,
        isTakeout,
        tzoffset,
        now,
      );
    } else if (def != null) {
      return isAvailableNow(def, isTakeout, tzoffset, now, null);
    } else return null;
  };
};
